// 空函数
export function noop() {}

// 函数promise化
export function promisify(func) {
  return (...args) => new Promise((resolve, reject) => {
    func(...args, (error, result) => (error ? reject(error) : resolve(result)));
  });
}

// 捕获并提取Promise错误对象
export async function catchError(promise) {
  return promise.then(data => [null, data]).catch(error => [error, null]);
}

// 去掉对象中的空属性
export function tinyObject(obj, condition) {
  return Object.keys(obj)
    .filter(key => condition(obj[key]))
    .reduce((acc, key) => ({
      ...acc,
      [key]: obj[key],
    }), {});
}

export function objToOptions(obj) {
  return Object.entries(obj)
    .map(([value, label]) => ({ value, label }));
}

export function getSearchObj(query) {
  return query.split('&')
    .reduce((acc, kvPair) => {
      const [k, v] = kvPair.split('=');
      acc[k] = v;
      return acc;
    }, {});
}
